export default __webpack_public_path__ + "static/media/inflammation@2x.ad27a45b.jpg";